// Module
var code = "<div class=\"loader formHeader\">\n    <asset cls=\"color{{$ctrl.colorName}}\" md-svg-src=\"{{$ctrl.icon}}\"></asset>\n    <div class=\"color{{$ctrl.colorName}}\">{{ 'COMING_SOON' | translate }}</div>\n</div>\n";
// Exports
module.exports = code;